import { getConfigLayout } from '@/services/layout';

export default {
  getConfigLayout: async ({ commit }) => {
    try {
      const { data } = await getConfigLayout();
      commit('setConfigHeader', data.header);
      commit('setConfigFooter', data.footer);
      commit('setConfigSidebar', data.sidebar);
      commit('setConfigLayout', data.config);
      ('defaultPage' in data) && (commit('setConfigDefaultPage', data.defaultPage));
      commit('setConfigLogin', data.login);
      commit('setConfigMenu', data.menu);
      commit('setConfigTheme', data.theme);
      commit('setConfigBreadcrumbs', data.breadcrumbs);
      commit('setConfigDialogs', data.dialogs);
      commit('setConfigLoading', data.loading);
      commit('setConfigPaths', data.paths);
      commit('setConfigExpiredMessage', data.expiredMessage);
      commit('setConfigForm', data.form)
      commit('setConfigDefaultActions', data.defaultActions ?? {})
      commit('setConfigEnvironmentDefaults', data.environmentDefaults ?? {})
    } catch (err) {
      console.error(err);
    }
  }
};
